export default class Results {
  constructor(data) {
    this.data = data;
    this.main = document.querySelector('.main-container');
    this.url = 'https://raw.githubusercontent.com/irinainina/rslang/rslang-data/data/';
  }

  bindEvents() {
    document.querySelector('.results-wrapper').addEventListener('click', (e) => this.playAudio(e));
    document.querySelector('.return').addEventListener('click', () => document.querySelector('.results-wrapper').classList.add('result-hidden'));
    document.querySelector('.return').addEventListener('click', () => this.removeBlur());
  }

  playAudio(e) {
    if (e.target.closest('.card-result')) {
      const audio = new Audio(`${this.url}${e.target.closest('.card-result').getAttribute('data-audio')}`);
      audio.play();
      console.log('2');
    }
  }

  removeBlur() {
      document.querySelector('.levels-wrapper').classList.remove('blur-active');
      document.querySelector('.image').classList.remove('blur-active');
      document.querySelector('.word-items').classList.remove('blur-active');
      document.querySelector('.buttons').classList.remove('blur-active');
  }

  renderResults() {
    const unknownWords = document.createElement('div');
    unknownWords.classList.add('unknown-words');
    const knownWords = document.createElement('div');
    knownWords.classList.add('known-words');
    const result = document.createElement('div');
    result.classList.add('results-wrapper');
    result.classList.add('result-hidden');
    result.append(unknownWords, knownWords);
    this.main.append(result);
    this.renderCards();
    this.renderButtons();
    this.bindEvents();
  }

  renderCards() {
    for (let i = 0; i < this.data.length; i += 1) {
      const card = document.createElement('div');
      card.classList.add('card-result');
      card.setAttribute('data-audio', `${this.data[i].audio}`);
      const p = document.createElement('p');
      p.classList.add('word-result');
      p.textContent = this.data[i].word;
      const transcr = document.createElement('p');
      transcr.classList.add('transcr-result');
      transcr.textContent = this.data[i].transcription;
      const transl = document.createElement('p');
      transl.classList.add('transl-result');
      transl.textContent = this.data[i].translation;
      card.append(p, transcr, transl);
      document.querySelector('.unknown-words').append(card);
    }
    const titleUnknown = document.createElement('p');
    titleUnknown.classList.add('unknown-title');
    titleUnknown.textContent = 'Не знаю';
    document.querySelector('.results-wrapper').prepend(titleUnknown);
    const titleKnown = document.createElement('p');
    titleKnown.classList.add('known-title');
    titleKnown.textContent = 'Знаю';
    document.querySelector('.known-words').prepend(titleKnown);
  }

  changeCard() {
    const words = [...document.querySelectorAll('.word-wrapper')];
    const known = [...document.querySelector('.unknown-words').children];
    for (let i = 0; i < words.length; i += 1) {
      if (words[i].classList.contains('word-wrapper--active')) {
        const word = words[i].firstChild.textContent;
        for (let j = 0; j < known.length; i += 1) {
          if (word === known[i].firstChild.innerText) {
            document.querySelector('.known-words').append(known[i]);
          }
        }
      }
    }
  }

  renderButtons() {
    const resultBtns = document.createElement('div');
    resultBtns.classList.add('result-btn-wrapper');
    const returnBtn = document.createElement('button');
    returnBtn.classList.add('return');
    returnBtn.textContent = 'Return';
    const newGame = document.createElement('button');
    newGame.classList.add('new-game');
    newGame.textContent = 'New Game';
    resultBtns.append(returnBtn, newGame);
    document.querySelector('.results-wrapper').append(resultBtns);
  }
}
